<template>
<div class="widthFull center pt-0 pb-3 mb-5 ">
  <loading v-if="loadingState" />
  <div class="csHeight2">
    <div class="row justify-content-center text-left pt-2 ">

      <div class="col-md-6 center mb-3 text-center pointer selectBlock" v-on:click="flow = 'cdp'" :class="{'blockActive': flow == 'cdp'}">
        <h1 class="mt-4" :class="{'grey': flow == 'poste' }"> <b> CDP </b> </h1>
        <h4 :class="{'grey': flow == 'poste' }">Cassa Depositi e Prestiti</h4>
      </div>

      <div class="col-md-6 center mb-3 text-center pointer selectBlock" v-on:click="flow = 'poste'" :class="{'blockActive': flow == 'poste'}">
        <h1 class="mt-4" :class="{'grey': flow == 'cdp' }"> <b> Poste Italiane </b> </h1>
        <h4 :class="{'grey': flow == 'cdp' }"> BancoPosta Affari</h4>
      </div>

      <!--  ACTUAL MONTH DISPOSALS ------------------------------------------------------------------------------------------------- -->

      <div class="col-md-12 center mb-4">

        <h4><b>Elenco Cessioni in corso</b></h4>

      </div>

      <!--     TABLE HEAD  -------------------------------------------------------------- -->
      <div class="widthFull row even mb-2">
        <div class="col-md-1 ">
          <small>N.Cessione</small>
        </div>
        <div class="col-md-2 ">
          <small>Data di creazione</small>
        </div>
        <div class="col-md-5 ">
          <small>Stato</small>
        </div>

        <div class="col-md-1 ">
          <small>Contratto</small>
        </div>
        <div class="col-md-1 ">
          <small>Movimentazione*</small>
        </div>

        <div class="col-md-2 text-right">
          <small>Importo di Cessione</small>
        </div>

      </div>

      <!--     TABLE BODY  -------------------------------------------------------------- -->
      <template v-for="(item,index,k) in disposals">
        <div class="widthFull row pt-2 mb-5" :class="{'pt-0': k == 0, 'even33': String(index / 2).includes('.') }">
          <div class="col-md-1 ">
            <b>{{ item.id }}</b>
          </div>
          <div class="col-md-2 ">
            <b>{{ moment(item.created_at).format('DD-MM-YYYY') }}</b>
          </div>
          <div class="col-md-5 ">
            <template v-if="item.state == 0">
              Creazione contratto di cessione a <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template>
            </template>
            <template v-if="item.state == 1">
              Spostamento del credito dal cassetto fiscale dell'installatore a <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template>
            </template>
            <template v-if="item.state == 2">
              Verifica <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template> in corso
            </template>
            <template v-if="item.state == 3">
              Cessione completata. Attendi il bonifico bancario di <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template> sul tuo conto corrente
              <template v-if="flow == 'cdp'" > indicato nel set Documenti per Eleggibilità CDP </template>
              <template v-else > IBAN BancoPosta Affari </template>

            </template>

            <template v-if="item.state == 5">
              Errore
            </template>

          </div>

          <div class="col-md-1 ">
            <font-awesome-icon v-if="item.contract" icon="check" size="1x" />
            <font-awesome-icon v-else-if="item.state == 0" icon="spinner" spin size="1x" />
          </div>
          <div class="col-md-1 ">
            <font-awesome-icon v-if="item.screenshot" icon="check" size="1x" />
            <font-awesome-icon v-else-if="item.state == 1" icon="spinner" spin size="1x" />
          </div>

          <div class="col-md-2 text-right">
            <b>€ {{ item.totalDisposalAmount | formatNumber }}</b>
          </div>

          <!-- CDP SCREENSHOT -->
          <div v-if="item.state == 1 && ( getProfile.delegate_move_credits == 2 || getProfile.delegate_move_credits == '2') " class="col-md-12 borderTop mt-2 pt-3 pb-3">

            <div class="row">

              <div class="col-md-5 pl-md-5">
                <h4 class="widthFull  black">
                  Per procedere con la Cessione a <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template>:
                </h4>
                  <p>
                    <b>1)</b>  Effettua lo spostamento del credito dal tuo cassetto fiscale a quello <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template>
                    <br/><br/> <span class="ml-4"> - codice fiscale di <template v-if="flow == 'cdp'" > CDP</template> <template v-else > Poste Italiane</template>: <b> {{ item.cessionaryCode }} </b> </span>

                    <br/><br/> <span class="ml-4"> Totale importo di Cessione per codice tributo:
                      <br/> <span class="ml-4"> - Ecobonus Ordinario <b> ( Codice Tributo 6922 ): €  {{ item.countEcobonus | formatNumber }} </b> </span>
                        <br/> <span class="ml-4"> - Ristrutturazione <b> ( Codice Tributo 6926 ): €  {{ item.countBonusCasa | formatNumber }} </b> </span>
                    </span>
                  </p>

                  <p>
                    <b>2)</b>  Fai una fotografia (screenshot) della movimentazione del credito sul tuo cassetto fiscale

                  </p>

                  <p>
                    <b>3)</b>  Carica la fotografia (screenshot) e clicca sul pulsante <b>"PROCEDI"</b>

                  </p>

              </div>

              <div class="col-md-6">

                <h4 class="widthFull center black">
                  Carica la fotografia (screenshot)
                </h4>
                <p class="center">che conferma la movimentazione del credito a <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template></p>

                <div class="front-image">

                  <input type="file" v-on:change="uploadFile" ref="fileInput" multiple name="invoiceFront" id="invoiceFront" class="fileInput" data-vv-as="screenshot"
                    v-validate="{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                    :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="niceInputLabel labelFileInput" for="invoiceFront">

                    <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                      <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
                    </span>

                    <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

                    </span>

                  </label>

                  <div v-if="errors.has('invoiceFront')" class="invalid-feedback" style="top:185px">
                    {{ errors.first('invoiceFront') }}
                  </div>

                  <div v-if="uploadFrontPercentage" class="progress mt-5" id="progFront">
                    <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                      {{ uploadFrontPercentage }} %
                    </div>
                  </div>

                  <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

                </div>


              </div>
              <div class="col-md-12 mt-5 mb-3 center">

                <a v-if="invoiceFrontBucket" v-bind:href="invoiceFrontBucket" target="_blank">
                  <a v-if="invoiceFrontBucket.substring(invoiceFrontBucket.lastIndexOf('.')+1, invoiceFrontBucket.length) == 'pdf'" class="center widthFull pdfLink" v-bind:href="invoiceFrontBucket" target="_blank">APRI PDF</a>
                </a>

              </div>

              <div class="col-md-12 center pt-1">
                <button type="button" v-on:click="confirmLoadScreenshot(item.id)" class="btn btn-primary btnRed">Procedi</button>
              </div>

            </div>

          </div>

          <!-- POSTE CONTRACT -->
          <div v-if="item.state == 0 && flow == 'poste'" class="col-md-12 borderTop mt-2 pt-3 pb-3">

            <div v-if="item.final_responce_message" class="row">

              <div class="col-md-12 pl-md-5">
                <h5 class="red center" v-html="item.final_responce_message"> </h5>
              </div>

            </div>

            <div class="row">

              <div class="col-md-5 pl-md-5">
                <h4 class="widthFull  black">
                  Per procedere con la Cessione a Poste Italiane:
                </h4>
                  <p>

                    <b>1)</b>  Accedi all'area riservata del tuo conto BancoPosta Business e sottoscrivi il contratto di Cessione del credito in funzione del codice tributo:
                    <!-- <br/><br/> <span class="ml-4"> - Il codice fiscale di <template v-if="flow == 'cdp'" > CDP</template> <template v-else > Poste Italiane</template>: <b> {{ item.cessionaryCode }} </b> </span>
                    -->
                    <br/><br/> <span class="ml-4"> Totale importo di Cessione per codice tributo:
                      <br/> <span class="ml-4"> - Ecobonus Ordinario <b> ( Codice Tributo 6922 ): €  {{ item.countEcobonus | formatNumber }} </b> </span>
                        <br/> <span class="ml-4"> - Ristrutturazione <b> ( Codice Tributo 6926 ): €  {{ item.countBonusCasa | formatNumber }} </b> </span>
                    </span>

                  </p>

                  <p>
                    <b>2)</b>  Carica contratto di Cessione ricevuto da Poste Italiane e clicca sul pulsante <b>"PROCEDI"</b>



                  </p>

              </div>

              <div class="col-md-6">

                <h4 class="widthFull center black">
                  Carica il contratto
                </h4>
                <p class="center">di Cessione del credito ricevuto da Poste Italiane</p>

                <div class="front-image">

                  <input type="file" v-on:change="uploadFile" ref="fileInput" multiple name="invoiceFront" id="invoiceFront" class="fileInput" data-vv-as="contratto di Cessione"
                    v-validate="{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                    :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="niceInputLabel labelFileInput" for="invoiceFront">

                    <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                      <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
                    </span>

                    <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

                    </span>

                  </label>

                  <div v-if="errors.has('invoiceFront')" class="invalid-feedback" style="top:185px">
                    {{ errors.first('invoiceFront') }}
                  </div>

                  <div v-if="uploadFrontPercentage" class="progress mt-5" id="progFront">
                    <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                      {{ uploadFrontPercentage }} %
                    </div>
                  </div>

                  <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

                </div>


              </div>
              <div class="col-md-12 mt-5 mb-3 center">

                <a v-if="invoiceFrontBucket" v-bind:href="invoiceFrontBucket" target="_blank">
                  <a v-if="invoiceFrontBucket.substring(invoiceFrontBucket.lastIndexOf('.')+1, invoiceFrontBucket.length) == 'pdf'" class="center widthFull pdfLink" v-bind:href="invoiceFrontBucket" target="_blank">APRI PDF</a>
                </a>

              </div>

              <div class="col-md-12 center pt-1">
                <button type="button" v-on:click="confirmLoadContract(item.id, item)" class="btn btn-primary btnRed">Procedi</button>
              </div>

            </div>

          </div>


          <div class="col-md-12 borderTop2 mt-2">
            Derivante dalle Pratiche: <b>{{ item.practices.replaceAll(',', ', ') }}</b>
          </div>

        </div>
      </template>



    </div>


    <div class="widthFull row  mb-2">
      <div class="col-md-8 ">

      </div>
      <div v-if="totalDisposal != 0" class="col-md-4 text-right">
        Importo totale Cessioni in corso <b>€ {{ totalDisposal | formatNumber }} </b>
      </div>
    </div>


  </div>
  <p class="widthFull  mt-5 ">* Trasferimento dei crediti dal cassetto fiscale dell'installatore a quello di <template v-if="flow == 'cdp'" > CDP </template> <template v-else > Poste Italiane </template> </p>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'
import Vue from 'vue'

import {
  dom
} from '@fortawesome/fontawesome-svg-core'


export default {
  name: 'DisposalAvailable',
  components: {

  },
  props: {

  },
  data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      flow: 'cdp',
      disposals: {},
      practices: {},
      loaded: false,
      countPractices: 0,
      moment: require('moment'),
      countValues: 0,

      min_disposal_price_cdp: process.env.MIN_DISPOSAL_PRICE_CDP,
      min_disposal_price_poste: process.env.MIN_DISPOSAL_PRICE_POSTE,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      totalDisposal: 0,

      countEcobonus: 0,
      countBonusCasa: 0,

      input: '',

    }

  },
  methods: {
    confirmLoadContract(val,disposal) {
      var _vue = this

      if (_vue.invoiceFrontBucket) {
        _vue.loadingState = true

        axios({
            url: process.env.ROOT_API + 'api/confirmLoadContractPoste',
            method: 'POST',
            data: {
              contract: _vue.invoiceFrontBucket,
              userToken: _vue.getProfile.userToken,
              disposal_id: val,
              user: _vue.getProfile,
              disposal: disposal,
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            console.log(resp)
            _vue.getDisposals()
            _vue.loadingState = false
            var text = ""
            if( _vue.getProfile.delegate_move_credits == 1 || _vue.getProfile.delegate_move_credits == '1' ){
              text = 'Abbiamo inviato la richiesta ad Advisor per spostare il tuo credito a Poste Italiane. Riceverai una conferma via e-mail una volta conclusa positivamente l`operazione. '
            }else{
              text = 'Per procedere con la Cessione del credito devi spostare il credito dal tuo cassetto fiscale al cessionario finale in base ai codici tributo presenti nella pratica di cessione. '
            }

            _vue.$swal({
              type: 'success',
              title: 'Contratto caricato con successo!',
              text: text,
            });

          })
          .catch(resp => {
            _vue.loadingState = false
            _vue.$swal({
              type: 'error',
              title: 'Oops...',
              text: 'Riprova piu tardi!',
            });
          })

      } else {
        _vue.$swal({
          type: 'error',
          title: 'Carica Contratto',
        });
      }

    },
    confirmLoadScreenshot(val) {
      var _vue = this

      if (_vue.invoiceFrontBucket) {
        _vue.loadingState = true

        axios({
            url: process.env.ROOT_API + 'api/confirmLoadScreenshotOfMoveCredits',
            method: 'POST',
            data: {
              screenshot: _vue.invoiceFrontBucket,
              userToken: _vue.getProfile.userToken,
              disposal_id: val,
              user: _vue.getProfile,
              flow: _vue.flow
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            console.log(resp)
            _vue.getDisposals()
            _vue.loadingState = false

            if( _vue.flow == 'poste' ){
              _vue.$swal({
                type: 'success',
                title: 'La Cessione del credito avvenuta con successo',
                text: 'Per maggiori info entra nella sezione Cessioni - Cessioni completate',
              });
            }

          })
          .catch(resp => {
            _vue.loadingState = false
            _vue.$swal({
              type: 'error',
              title: 'Oops...',
              text: 'Riprova piu tardi!',
            });
          })

      } else {
        _vue.$swal({
          type: 'error',
          title: 'Carica Screenshot',
        });
      }

    },
    async getDisposals() {
      if (this.getProfile) {
        this.loaded = false
        var data = this.getProfile
        var _vue = this
        _vue.loadingState = true
        axios({
            url: process.env.ROOT_API + 'api/getDisposals',
            method: 'POST',
            data: {
              type: 'inwork',
              user_token: data.userToken,
              flow: this.flow
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            var disposals = resp.data.disposals
            _vue.practices = resp.data.practices
            _vue.totalDisposal = 0

            for (var x in disposals) {

              // COUNT TOTAL VALUE
              var p = disposals[x].totalDisposalAmount
              p = parseFloat(p.replace(',', '.'))
              _vue.totalDisposal = _vue.totalDisposal + p

              // COUNT VALUES FOR SINGLE DISPOSAL DIVIDED BY TRIBUTE CODE
              var countEcobonus = 0
              var countBonusCasa = 0
              var practices = disposals[x].practices.split(",");
              for (var z in practices) {

                if (_vue.practices[practices[z]].bonus == 'Bonus Casa 50%') {

                  countBonusCasa = countBonusCasa + parseFloat(_vue.practices[practices[z]].finalAmmount)

                } else {

                  countEcobonus = countEcobonus + parseFloat(_vue.practices[practices[z]].finalAmmount)

                }
              }

              countBonusCasa = countBonusCasa.toFixed(2)
              countEcobonus = countEcobonus.toFixed(2)

              disposals[x]['countBonusCasa'] = countBonusCasa
              disposals[x]['countEcobonus'] = countEcobonus



            }

            _vue.totalDisposal = _vue.totalDisposal.toFixed(2)

            _vue.disposals = disposals



            _vue.loaded = true
            _vue.loadingState = false

            _vue.uploadFrontPercentage = 0
            _vue.invoiceFront = ''
            _vue.invoiceFrontBucket = ''
            _vue.input.target.value = null

          })
          .catch(resp => {

            _vue.loadingState = false
          })

      }
    },

    uploadFile: function(input) {
      this.input = input
      var file = input.target.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.target.files[0].size


      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        var t = 0
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1
        }

        this.loadingState = true

        axios.post(process.env.ROOT_API + 'api/uploadImageInvoice',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {
                this.uploadFrontPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              }.bind(this)
            }
          ).then(function(e) {
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.loadingState = false
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFrontBucket = e.data.fattura

            } else {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFront = ''
              _vue.invoiceFrontBucket = ''
              _vue.UploadError()
              input.target.value = null
              _vue.loadingState = false
            }

          })
          .catch(function() {
            _vue.uploadFrontPercentage = 0
            _vue.invoiceFront = ''
            _vue.invoiceFrontBucket = ''
            _vue.UploadError()
            input.target.value = null
            _vue.loadingState = false

          });
      }

    },

  },
  watch: {
    iban: function(value) {
      this.iban = value.toUpperCase().trim()
      this.iban = this.iban.replace(' ', '')
    },
    flow: function(val) {
      this.getDisposals()

      if (val == 'cdp') {
        this.min_disposal_price_cdp = process.env.MIN_DISPOSAL_PRICE_CDP
      } else {
        this.min_disposal_price_cdp = process.env.MIN_DISPOSAL_PRICE_POSTE
      }

    },
    async getProfile() {
      await this.getDisposals()
    },
  },
  created() {

    console.log('Section 1 LOADED')

  },

  async mounted() {

    await this.getDisposals()

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="css" scoped>

  .csHeight2{
    min-height: 52vh!important;
  }

.selectListBox {
  background: #d4ebe9;
  border: 1px solid grey;
  padding: 3%;
  max-height: 254px;
  height: 254px;
  overflow-y: scroll;
  transition: all .1s;
}

.borderTop{
  border-top: 1px solid lightgrey!important;

}

.borderTop2{
  border-top: 1px solid lightgrey;

}

.lightYellow {
  background:   #f393241c
}
  .custLabelFontSize{
    font-size: 14px;
  }

  .selectBlock{
    background: #eeeeee;
    border: 1px solid #a5a5a5;
    border-top: none;
  }

  .blockActive{
    background: white;
    border-bottom: none!important;
  }

</style>
<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 177px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 200px;
        z-index: 10;
        top: -20px;
    }

    > label {
        /*display: none;*/

        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 192px;
            margin-top: 19px !important;
            display: block;
            height: 155px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 5px;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 29px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;

            &:before {
                content: "+";
                display: block;
                clear: both;
                text-align: center;
                height: 141px;
                width: 179px;
                border-radius: 7px;
                padding-top: 51px;
                font-size: 51px;
                font-weight: 600;
                color: #00917e;
                border: 3px solid #00917e;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 237px;
            font-size: 10px;
            text-decoration: underline;
            color: black;

            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/cessioni/practicesinWork.vue